module.exports = __webpack_public_path__ + "img/nexultra-uv-icon.470096f8.svg";